const getExtension = (file) => {
  let ext = ""
  const index = file.name.lastIndexOf(".")
  ext = file.name.substring(index + 1)
  return ext
}

export { getExtension }
